import $http from '@/modules/core/services/http.service';
import Endpoints from '@/constants/endpoints';


export default class BudgetService {

    public static getStudyBudget(studyId: string) {
        return $http.get(Endpoints.sutdyBudget(studyId));
    }

    public static createStudyBudget(payload: any) {
        return $http.post(Endpoints.budget, payload);
    }
}
